import { Instagram, Mail, MapPin, Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-ink text-white">
      <div className="mx-auto max-w-6xl px-5 sm:px-8 py-16">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <div>
            <img src="/assets/logo-cut.png" alt="ZoJu Juices" className="h-16 w-auto" />
            <p className="mt-4 max-w-xs font-script text-3xl text-white/80">Fresh. Fun. Fueled by Nature.</p>
          </div>
          <div className="flex flex-col gap-4">
            <a href="https://instagram.com/ZoJuices" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 text-white/80 transition-colors hover:text-watermelon" data-testid="footer-instagram">
              <Instagram className="h-5 w-5" /> @ZoJuices
            </a>
            <a href="mailto:Support@zojuices.com" className="inline-flex items-center gap-3 text-white/80 transition-colors hover:text-watermelon" data-testid="footer-email">
              <Mail className="h-5 w-5" /> Support@zojuices.com
            </a>
            <span className="inline-flex items-center gap-3 text-white/80">
              <MapPin className="h-5 w-5" /> Orlando, Florida
            </span>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/15 pt-6 text-sm text-white/50 sm:flex-row">
          <span>© {new Date().getFullYear()} ZoJu Juices</span>
          <span className="inline-flex items-center gap-1.5">
            Made with <Heart className="h-4 w-4 text-watermelon" fill="#FF4D6D" /> in Orlando
          </span>
        </div>
      </div>
    </footer>
  );
}
